import { ActionType } from "../action-types/type";

import AuthService from "../../services/authService";
import { Dispatch } from "redux";
import { AuthAction } from "../actions/index";
import useAccessBlockStore from "../../store/useAccessBlockStore";

export const register =
  (
    username: string,
    password: string,
    role: string,
    isAccountNonExpired: number,
    isAccountNonLocked: number,
    isCredentialsNonExpired: number,
    isEnabled: number
  ) =>
  (dispatch: Dispatch<AuthAction>) => {
    return AuthService.register(
      username,
      password,
      role,
      isAccountNonExpired,
      isAccountNonLocked,
      isCredentialsNonExpired,
      isEnabled
    ).then(
      (response) => {
        dispatch({
          type: ActionType.REGISTER_SUCCESS,
        });

        dispatch({
          type: ActionType.SET_MESSAGE,
          payload: response.data.message,
        });
        return Promise.resolve();
      },
      (error) => {
        const message: string =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        dispatch({
          type: ActionType.REGISTER_FAIL,
        });

        dispatch({
          type: ActionType.SET_MESSAGE,
          payload: message,
        });
        return Promise.reject();
      }
    );
  };

export const login = (data: any) => (dispatch: Dispatch<AuthAction>) => {
  return dispatch({
    type: ActionType.LOGIN_SUCCESS,
    payload: { user: data },
  });
};

export const loginFailed = () => (dispatch: Dispatch<AuthAction>) => {
  return dispatch({
    type: ActionType.LOGIN_FAIL,
  });
};

/**
 * Persist the rotated tokens / refreshed roles returned by /api/refresh.
 */
export const refreshTokenSuccess =
  (data: any) => (dispatch: Dispatch<AuthAction>) => {
    return dispatch({
      type: ActionType.REFRESH_TOKEN_SUCCESS,
      payload: { user: data },
    });
  };

export const messageAction =
  (message: any) => (dispatch: Dispatch<AuthAction>) => {
    return dispatch({
      type: ActionType.SET_MESSAGE,
      payload: message,
    });
  };

export const updateUserRoles =
  (data: any) => (dispatch: Dispatch<AuthAction>) => {
    return dispatch({
      type: ActionType.UPDATE_USER_ROLES,
      payload: { roles: data.roles },
    });
  };

// export const login =
// (username: string, password: string) => (dispatch: Dispatch<AuthAction>) => {
//   return AuthService.login(username, password).then(
//     (data: any) => {
//       dispatch({
//         type: ActionType.LOGIN_SUCCESS,
//         payload: { user: data },
//       });
//       return Promise.resolve(data);
//     },
//     (error: any) => {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();

//       dispatch({
//         type: ActionType.LOGIN_FAIL,
//       });

//       dispatch({
//         type: ActionType.SET_MESSAGE,
//         payload: message,
//       });

//       return Promise.reject();
//     }
//   );
// };

/**
 * User-initiated logout (the "Log out" button). Revokes both tokens
 * server-side (denylists the access token, clears + revokes the refresh
 * cookie) then clears the client session.
 */
export const logout = () => (dispatch: Dispatch<AuthAction>) => {
  // Revoke server-side first (best-effort, fire-and-forget): this reads the
  // current access token + refresh cookie synchronously, so it must run BEFORE
  // we clear the client session below.
  AuthService.serverLogout().catch(() => {
    /* best-effort: client logout proceeds regardless */
  });
  AuthService.logout();
  // A user-initiated logout escapes any subscription-expired block (a churned company's off-board block
  // is kept deliberately by the interceptor's own raw dispatch, which does not run this thunk).
  useAccessBlockStore.getState().clear();
  return dispatch({
    type: ActionType.LOGOUT,
  });
};

/**
 * Forced/automatic logout when the session can't be refreshed (access token
 * expired and the refresh cookie is gone/expired/revoked). Client-only: it does
 * NOT call the server logout, so a transient refresh failure can never revoke a
 * still-valid refresh token or clear its HttpOnly cookie. This is what 401
 * handlers and the refresh interceptor use; only the explicit logout() button
 * revokes server-side.
 */
export const expireSession = () => (dispatch: Dispatch<AuthAction>) => {
  AuthService.logout();
  useAccessBlockStore.getState().clear();
  return dispatch({
    type: ActionType.LOGOUT,
  });
};
